import {Component, Inject, OnInit, ViewChild, ViewEncapsulation} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AppService} from "@irb/app.service";
import {ModelsService} from "@irb/irb-models/models-new/models.service";
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import {IrbModelsEvents} from "@irb/irb-models/irb-models.events";
import {IrbAppEvents} from "@irb/app.events";
import {AnalyticsService} from "@irb-common/analytics/analytics.service";


@Component({ standalone: false,
  selector: 'irb-edit-existing-blended-model',
  templateUrl: './edit-existing-blended-model.component.html',
  styleUrls: ['../../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EditExistingBlendedModel implements OnInit {

  canNotContinue = true;
  disabledDropDown = true;
  listOfModelsForDropDown:any[] = [];
  selectedModel: any;
  @ViewChild('IrbDropdownBlendedModels') IrbDropdownBlendedModels: any;
  private blendedModels:any[] = [];

  constructor(public dialogRef: MatDialogRef<EditExistingBlendedModel>,
              public as: AppService,
              public modelsService: ModelsService,
              private ats: AnalyticsService,
              @Inject(MAT_DIALOG_DATA) public eventData: any) {
  }

  ngOnInit() {
    this.selectedModel = null;
    this.modelsService.getBlendedModelNamesDropDown().subscribe((responseBlendedModels: any) => {

      if (responseBlendedModels && responseBlendedModels.items.length) {
        this.blendedModels = responseBlendedModels.items;
        let md: any;
        this.blendedModels.forEach((model: any) => {
          md = {
            value: model.id,
            name: model.name
          };
          this.listOfModelsForDropDown.push(md);
        });
        this.listOfModelsForDropDown = this.sortArrayList(this.listOfModelsForDropDown)
      }
      this.disabledDropDown = false;
    });
  }

  sortArrayList(arrayList: any) {
    return arrayList.sort((a:any, b:any) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  }

  close() {
    this.dialogRef.close();
  }

  openBlended() {
    this.ats.trackClickEvent("lc_mmc_edit_cont");
    let passedEventData: any = {
      name: this.selectedModel.name,
      securityModelId: this.selectedModel.value,
      modelId: this.selectedModel.value
    }
    passedEventData.fullscreen = true;
    passedEventData.type = "Blended";
    //passedEventData.isDraft = true;
    passedEventData.addToExistedBlendedModel = true;
    passedEventData.onClose = () => {
      this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
        severity: "warn",
        summary: "Incomplete Blended Model",
        detail: "To use this model, allocations must equal 100%."
      });
      this.as.fireEvent(IrbAppEvents.GRID_REFRESH, {'slot': 'A'});
    }
    if (this.eventData?.modelIds) {
      passedEventData.mmcModelIds = this.eventData.modelIds;
    }

    this.as.fireEvent(IrbModelsEvents.SHOW_EDIT_MODEL, passedEventData);
    this.close();
  }

  getModels(searchStr: any) {
    const f = DropdownFilterComponent.getFilteredList(searchStr, this.listOfModelsForDropDown);
    this.IrbDropdownBlendedModels.set(f);
  }

  onSelectModel(_item: any) {
    this.canNotContinue = false;
  }
}
